import React from "react";
import { DatePicker } from "@progress/kendo-react-dateinputs";
import TooltipHLPure from "../tooltipHL/tooltipHL.pure";
import Traslates from "../traslates/traslates.pure";
import "./datePickerHL.css";

const DataPickerHLPure = (props) => {
  const {
    id,
    labelDataPicker, //Label dataPicker
    valueDate, //Date select
    maxDate, //Max date
    limitDate, //Limit date
    errorInput, //Error true or false
    errorDatePicker, //Error text to show
    handleChangeDate, //Function to change date
    handleBlurDate, //Function to handle on blur
    tooltipShow, //True or false to show tooltip
    titleTooltip, //Title tooltip string
    positionTooltip, //Position tooltip (top, left, right, bottom) string
    descriptionTooltip, //Description tooltip string
    subContent, //More text to tooltip description
    restContent, //More text to tooltip description
    informationIcon, // Choose the information icon true or false to custom img
    disabled = false, //True to disable input
    formatPicker,
    required
  } = props;

  //Example to use
  // const [valueDate, setValueDate] = useState(dateFrom || null);

  // const handleChange = (event) => {
  //   setValueDate(event.value);
  // };

  return (
    <div className="dataPickerHLPure-container">
      <div className="dataPickerHLPure-container-text">
        {labelDataPicker && <label for={id || "date"} className="dataPickerHLPure-label">{labelDataPicker}</label>}
        {required && ' *'}
        {tooltipShow ? (
          <TooltipHLPure
            positionTooltip={positionTooltip}
            titleTooltip={titleTooltip}
            descriptionTooltip={descriptionTooltip}
            subContent={subContent}
            restContent={restContent}
            informationIcon={informationIcon}
          />
        ) : (
          ""
        )}
      </div>
      <Traslates>
        <DatePicker
          id={id || "date"}
          name={"date"}
          min={limitDate}
          max={maxDate}
          value={valueDate}
          format={formatPicker || "dd/MMM/yyyy"}
          onChange={handleChangeDate}
          onBlur={handleBlurDate}
          className="dataPickerHLPure-style"
          disabled={disabled}
        />
      </Traslates>
      {errorInput &&
        <div className="dataPickerHLPure-hints">
          <span className="hint-message-error">{errorDatePicker}</span>
        </div>
      }
    </div>
  );
};

export { DataPickerHLPure as default };

